import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-07-23'
        tag='Crosslisting'
        title='Crosslisting Apps: Features and Comparisons'
      >
        <p>
          Many people nowadays are selling online as it indeed is a good source of income. The popularity of online
          shopping for so many things, including second-hand items, has been on the rise in the past few years,
          especially now that the world is experiencing a pandemic that requires most of us to stay home; hence shopping
          in physical stores is inconvenient. Thanks to different online marketplaces, not only does it allow you to buy
          the things that you need in the comforts of your home, but it also enables you to sell things regardless of
          whether they are new or used. While selling in different online marketplaces can be a part-time job, there are
          also other sellers who sell full-time. And because they have a bulk of items to list and manage, it can become
          time-consuming and require a lot of effort. This results in many sellers using cross-listing apps. Through the
          use of listing software, it enables sellers to list in different platforms, track items easily, increase their
          listing exposure and engagement, as well as increase sales, and save time.
        </p>
        ​
        <p>
          We know how confusing it can be when it comes to deciding which app is best for you. So, we have listed each
          and every cross-listing app that you can find in the market to see how each differs from each other and give
          you insights into which suits you and your reselling business.
        </p>
        ​<h3>OneShop</h3>
        <p>
          OneShop is the newest cross-posting app in the market and is still in the works to make listing across
          multiple e-commerce marketplaces easier and faster. To help ease the time-consuming and laborious tasks of
          listing on different platforms, OneShop is intelligently made to help many sellers save time and effort. The
          days of manually performing daily tasks to grow your business are over as OneShop will help you increase your
          items' exposure and, in turn, your sales. Not only does it can help you have an advantage on your Poshmark
          closet, but it can also help you automate many functions across many marketplaces that our team will
          integrate.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Upload images, draft your listings and cross-post on multiple selling platforms</li>
          <li>Move all of your inventory data into OneShop </li>
          <li>
            Check and manage your product listings and your sales on the go using your iOS/Android device through the
            app{' '}
          </li>
          <li>Performs on-marketplace marketing strategies like sending offers, discounts, and relisting</li>
          <li>Sales Analytics</li>
          <li>Has a responsive customer support team</li>
          <li>Automatically delist listing everywhere once your item is sold </li>
          <li>Background removal for images via PhotoRoom</li>
          <li>Available for Canada-based seller</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Getting Started subscription for $45 per month</li>
          <li>Growing subscription for $55 per month</li>
          <li>Full-time subscription for $85 per month</li>
          <li>Unlimited subscription for $120 per month</li>
        </ul>
        ​<h3>List Perfectly</h3>
        <p>
          List Perfectly aims to provide solutions to solve the frustrating and laborious process of listing on multiple
          marketplaces and help online resellers work smarter while reaching new customers and having more sales. As of
          writing, this software has the most marketplaces where you can cross-post. This includes Poshmark, Tradesy,
          Shopify, eBay, Etsy, Grailed, Instagram, Depop, Facebook Marketplace, Kidizen, and Mercari.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Cross-post to multiple platforms with templates</li>
          <li>Bulk cross-posting</li>
          <li>Inventory management</li>
          <li>Access analytics</li>
          <li>Download CSV</li>
          <li>Import, add, and save products in LP Catalog </li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Simple plan: $29 per month</li>
          <li>Business plan: 49 per month</li>
          <li>Pro plan: $69 per month</li>
        </ul>
        ​<h3>Vendoo</h3>
        <p>
          Vendoo was founded to help online sellers run their business more efficiently and be able to sell on multiple
          marketplaces. As of writing, this software supports cross-posting in platforms such as Poshmark, eBay,
          Mercari, Depop, Etsy, Grailed, Facebook Marketplace, Tradesy, and Kidizen.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Cross list items</li>
          <li>Import listings from another marketplace</li>
          <li>Delist and relist items</li>
          <li>Image hosting</li>
          <li>Image resizer & editor</li>
          <li>Sales analytics</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Starter Plan for $8.99 per month</li>
          <li>Simple plan for $19.99 per month</li>
          <li>Plus plan for $29.99 per month</li>
          <li>Pro Plan for $49.99 per month</li>
          <li>Advance Plan for $99.99 per month</li>
          <li>Expert plan for $149.99 per month</li>
        </ul>
        ​<h3>ResellKit</h3>​
        <p>
          ResellKit is another cross-listing app designed to increase your productivity in marketplaces such as eBay,
          Poshmark, and Mercari. Its goal is to be the tool that increases sellers' productivity in the online
          marketplace. This software is currently available only on Mac, Windows, and Linux. ResellKit does not offer
          monthly subscriptions but packages that you can purchase if you need to cross-list more items.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Bulk cross-listing</li>
          <li>Import listings from another marketplace</li>
          <li>Export CSV</li>
          <li>Delist sold items across platforms (Autopilot beta)</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Free package: $0, including 50 new listings monthly</li>
          <li>Basic package: $9, including 100 new listings (non-expiring)</li>
          <li>Plus package: $14, including 200 new listings (non-expiring)</li>
          <li>Advanced package: $29, including 750 new listings (non-expiring)</li>
          <li>Pro package: $69, including 2500 new listings (non-expiring)</li>
        </ul>
        ​<h3>SellerInsight</h3>
        <p>
          Another cross-posting app in the market is Seller Insight. It is said to provide insights and tools that can
          help you level up your Poshmark game. This app works on the phone or tablet, which makes it handy anytime,
          anywhere. This app can cross-post across Poshmark, eBay, and Mercari.{' '}
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Real-time sales and inventory dashboard </li>
          <li>Sales and inventory data </li>
          <li>Product relisting</li>
          <li>Crossposting</li>
          <li>Works on Android devices</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Offers a 7-day free trial</li>
          <li>Monthly subscription of $9.99 per month </li>
        </ul>
        ​<h3>PrimeLister</h3>
        <p>
          PrimeLister is a cross-posting service that also offers Poshmark automation. It is a Chrome extension; hence
          it is not supported on mobile devices like phones and tablets. It can cross-post to Poshmark, Mercari.
          Facebook marketplace, eBay, Etsy, and Depop.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Cross Listing items</li>
          <li>Bulk listing</li>
          <li>Schedule listing</li>
          <li>Auto Relisting </li>
          <li>Product delisting </li>
          <li>Inventory management</li>
          <li>Tag and groups</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Offers 7-day free trial</li>
          <li>Basic plan: $20.83 per month</li>
          <li>Pro plan: $33.33 per month</li>
        </ul>
        ​<h3>Cross List It</h3>
        <p>
          Cross List It is a Chrome extension cross-listing software. It can cross-list in marketplaces like eBay, Etsy,
          Poshmark, Mercari, and Depop with a few clicks of the mouse.{' '}
        </p>
        ​<h4>Features:</h4>​
        <ul>
          <li>Cross-posting across platforms</li>
          <li>Offers Marketplace Profit Calculator</li>
        </ul>
        ​<h4>Pricing:</h4>​
        <ul>
          <li>Offers a 7-day free trial</li>
          <li>Monthly subscription of $9.99 per month </li>
        </ul>
        ​<h3>Hammoq</h3>​
        <p>
          Hammoq is a cross-listing service that offers effortless selling across multiple platforms. All you have to do
          is submit the photos and condition of your items, and they will do the rest. They can cross-post listing
          across marketplaces such as Poshmark, Mercari, Tradesy, Depop, Amazon, Shopify, eBay, StockX, and OfferUp.
          They offer different types of services per plan, which may include some or all of the features.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Provides listing titles and description</li>
          <li>Provides measurements</li>
          <li>Provides product characteristics</li>
          <li>Pricing</li>
          <li>Shipping</li>
          <li>Unlimited Revisions</li>
          <li>It gives you an Account manager</li>
          <li>It gives you a Virtual Assistant</li>
          <li>Open communication channels</li>
          <li>Fully customizable and tailored solutions based on their needs</li>
          <li>Team of dedicated virtual assistants</li>
          <li>US quality assurance specialist</li>
          <li>Seamless integration with any eCommerce platform and any third-party app</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Monthly base subscription: $99, which works like a credit</li>
          <li>Essential plan: $0.90 a listing </li>
          <li>Accelerated plan: $1.45 a listing</li>
          <li>Enterprise plan (upon inquiry)</li>
        </ul>
        ​<h3>ListingJoy</h3>​
        <p>
          ListingJoy is a software that lets you create and cross-post listings with all major marketplaces with the
          click of a button. It can cross-list in marketplaces such as Poshmark, Mercari, Facebook marketplace, Etsy,
          and eBay. As of writing, signups for ListingJoy are currently closed.
        </p>
        ​<h4>Features:</h4>
        <ul>
          <li>Cross-posts</li>
          <li>Unlimited Listings</li>
          <li>Supports All Marketplaces</li>
          <li>Unlimited Importing / Syncing</li>
          <li>Delisting + Relisting</li>
        </ul>
        ​<h4>Pricing:</h4>
        <ul>
          <li>Monthly Unlimited plan: $39.99 per month (but is now FREE for new users due to the COVID-19 crisis)</li>
        </ul>
        ​
        <p>
          These cross-listing services are just some of what you can find in the market. The key to choosing the right
          software for you is to find out what you really need help with in managing your business. But one thing is for
          sure, this software and apps can definitely save you a lot of time and effort when it comes to cross-listing
          your items across platforms. If you want something that can do more than cross-listing, opt for a service that
          offers many features so that you won't have to manually do tasks on your own, babysit multiple platforms, and
          sit in front of your device for long periods.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
